import React, { useState, useEffect, ChangeEvent, useCallback } from 'react';

import Service from './ads.service';
import { useCookies } from 'react-cookie'
import Header from '../header/header.component';
import { FileRejection, useDropzone } from 'react-dropzone';
import Config from "../../config/config";
import { FileDTO } from './ads.dto';

interface FileUploadProps { }

const Ads = () => {
    const [session] = useCookies(['access_token_session']);
    const [files, setFiles] = useState<FileDTO[]>([]);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [fileName, setFileName] = useState<string>('');
    const [error, setError] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const [link, setLink] = useState<string>('');
    const onSearchResult = useCallback(
        (textSearch: String) => {

        }, []);

    // Fetch all files from server
    useEffect(() => {
        fetchFiles();
    }, []);

    const fetchFiles = async () => {
        try {
            //   const response = 

            //   await axios.get<{ files: string[] }>('http://localhost:3000/files/all');
            Service.getAll(session.access_token_session).then((response) => {
                // setListGrammar(res.data.grammarData);
                setFiles(response.data.files);
            }).catch(err => {
                console.log(err)
            })

        } catch (error) {
            console.error('Error fetching files:', error);
        }
    };

    // const handleFileSelect = (event: ChangeEvent<HTMLInputElement>) => {
    //     setSelectedFiles(event.target.files);
    // };

    const handleFileUpload = async () => {
        if (!selectedFiles) {
            setError('Vui lòng chọn file để upload');
            return;
        }

        if (selectedFiles.length > 1) {
            setError('Mỗi lần chỉ được upload 1 file. Xin vui lòng chọn lại');
            return;
        }



        let isError = false;
        const formData = new FormData();
        for (let i = 0; i < selectedFiles.length; i++) {
            formData.append('files', selectedFiles[i]);
            formData.append('link', link);
            const image = new Image();
            const fileURL = URL.createObjectURL(selectedFiles[i]);

            image.src = fileURL;

            const checkImageSize = () => {
                return new Promise<void>((resolve, reject) => {
                    image.onload = () => {
                        // Kiểm tra nếu width = 2 * height
                        // if (image.width !== 2 * image.height) {
                        //     setError(`Hình ảnh ${selectedFiles[i].name} không có tỉ lệ chiều rộng gấp đôi chiều cao.`);
                        //     reject();
                        // } else {
                        //     resolve();
                        // }
                        resolve();
                    };

                    image.onerror = () => {
                        setError(`Không thể tải tấm hình ${selectedFiles[i].name}`);
                        reject();
                    };
                });
            };

            try {
                await checkImageSize();  // Chờ kiểm tra xong kích thước ảnh
            } catch {
                isError = true;
                return;  // Ngừng quá trình upload nếu có lỗi
            }
        }
        if (isError) {
            return;
        }

        try {
            Service.uploadFile(session.access_token_session, formData).then((response) => {
                setMessage(response.data.message);
                setError('');
                fetchFiles();
                setSelectedFiles([]); // Refresh file list
            }).catch(err => {
                console.log(err)
            })


        } catch (error: any) {
            setError(error.response?.data?.message || 'Upload thất bại');
            setMessage('');
        }
    };

    const handleFileDelete = async (filename: string) => {
        try {
            // await axios.delete(`http://localhost:3000/files/${filename}`);
            Service.deleteFile(session.access_token_session, filename).then(() => {
                fetchFiles();
            });
            // Refresh file list after deletion
        } catch (error) {
            console.error('Error deleting file:', error);
        }
    };
    const onDrop = (acceptedFiles: File[], fileRejections: FileRejection[]) => {
        console.log("onDrop:", fileRejections.length)
        if (fileRejections.length > 1) {
            setError('Bạn chỉ được upload 1 file');
            return;
        }
        setSelectedFiles(acceptedFiles);
        if (acceptedFiles.length > 0) {
            setFileName(acceptedFiles[0].name);
        }
        setError('');
        setMessage('');
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple: false });

    return (
        <div>
            <Header title={'90 câu ngữ pháp topik I'} pageActive={'GRAMMAR'} textSearch={'90 câu ngữ pháp...'} onSearchResult={onSearchResult} />
            <div style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'row', marginTop: 50 }}>
                <div style={{ padding: '20px', flexDirection: 'column', display: 'flex' }}>
                    <h2>Upload Files</h2>

                    <div
                        {...getRootProps()}
                        style={{
                            border: '2px dashed #cccccc',
                            padding: '20px',
                            textAlign: 'center',
                            backgroundColor: isDragActive ? '#f0f0f0' : '#fafafa',
                            cursor: 'pointer',
                        }}
                    >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                            <p>Drop the files here...</p>
                        ) : (
                            <p>Drag & drop some files here, or click to select files. Please enter image size width = 2 * height</p>
                        )}
                    </div>

                    {fileName.length > 0 && <span style={{ padding: '5px' }}> {fileName} </span>}

                    <input type="text" placeholder="Nhập link quảng cáo" name="search" onChange={(e) => setLink(e.target.value)} style={{ marginTop: '5px', marginBottom: '5px' }} />

                    <button onClick={handleFileUpload} className="btn btn-success">Upload</button>

                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    {message && <p style={{ color: 'green' }}>{message}</p>}


                </div>
                <div style={{ padding: '20px' }}>
                    <h3>Files List</h3>
                    <ul>
                        {files.length > 0 ? (
                            files.map((file, index) => (
                                <li key={index}>
                                    <a href={file.link}>
                                        <img
                                            src={`${Config.domain + Config.API_URL.ADS.UPDATE + file.fileName}`}
                                            alt={file.fileName}
                                            style={{ width: '350px', height: 'auto', marginRight: '10px' }}
                                        />
                                    </a>
                                    <button onClick={() => handleFileDelete(file.fileName)} style={{ marginLeft: '10px' }} className="btn btn-danger">
                                        Delete
                                    </button>
                                </li>
                            ))
                        ) : (
                            <li>No files uploaded yet</li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Ads;
